import * as React from 'react';
import { Select } from '../../../../../Passenger/components/Field/Select/Select';
import { useSelector } from 'react-redux';
import { PassengerFieldOption } from '../../../../../Passenger/types';
import { getPassengerLabels } from '../../../../../Checkout/store/passengers/selectors';
import { useTranslation } from 'react-i18next';
import { useDownloadOrderDocument } from '../../../../../Checkout/components/Checkout/hooks';
import Button from '../../../../../Button/Button';
import { useTheme } from '../../../../../theme';
import { Field, Form } from 'react-final-form';
import DocumentsList, { NAS_AND_TOURS_SINGLE_OPTION } from './DocumentsList';
import { OrderDocumentType } from '@websky/graphql';

interface Props {
	everyPortPassengerIds?: string[];
	withEveryTravelServices?: boolean;
}

const Download: React.FC<Props> = ({ everyPortPassengerIds, withEveryTravelServices }) => {
	const passengers = useSelector(getPassengerLabels);

	const { t } = useTranslation('FlightInfoCard');
	const theme = useTheme('FlightInfoCard').TicketsModal;

	const { handleDownload, loading } = useDownloadOrderDocument();

	const getPassengersList: PassengerFieldOption[] = React.useMemo(() => {
		const fields: PassengerFieldOption[] = [
			{
				key: 'all',
				value: t('All passengers')
			}
		];

		Object.keys(passengers).forEach(passengerId => {
			fields.push({
				key: passengerId,
				value: passengers[passengerId]
			});
		});

		return fields;
	}, [passengers]);

	const onSubmit = async (values: any) => {
		await handleDownload(
			values['passengers'] !== 'all' ? values['passengers'] : null,
			values['documents'] !== 'all'
				? values['documents'] === NAS_AND_TOURS_SINGLE_OPTION
					? OrderDocumentType.NASTicket
					: values['documents']
				: null
		);

		if (values['documents'] === NAS_AND_TOURS_SINGLE_OPTION) {
			await handleDownload(
				values['passengers'] !== 'all' ? values['passengers'] : null,
				OrderDocumentType.EveryTravelTicket
			);
		}
	};

	return (
		<Form onSubmit={onSubmit}>
			{({ handleSubmit }) => (
				<form onSubmit={handleSubmit}>
					<div className={theme.downloadContainer}>
						<Field
							name="passengers"
							defaultValue="all"
							render={({ input }) => (
								<Select
									options={getPassengersList}
									value={input.value}
									name={'passengers'}
									label={null}
									onChange={input.onChange}
									onBlur={input.onBlur}
									className={theme.select}
								/>
							)}
						/>

						<DocumentsList
							everyPortPassengerIds={everyPortPassengerIds}
							withEveryTravelServices={withEveryTravelServices}
						/>

						<div className={theme.buttons}>
							<Button isLoading={loading} className={theme.button} type="submit" variant="flat">
								{t('Download')}
							</Button>
						</div>
					</div>
				</form>
			)}
		</Form>
	);
};

export default Download;
